export const DeveloperProfileConstants = {
  KEYS: {
    JOB_FUNCTION: "jobFunction",
    EXPERIENCE: "experience",
    EXPERTISE: "expertise",
    LANGUAGES: "language",
    TOPICS: "topics",
    GITHUB_USERNAME: "githubUsername",
    OTHER_LANGUAGE: "otherLanguage",
    OTHER_TOPIC: "otherTopic",
  },

  OPTIONS: {
    jobRoles: [
      { label: "Backend Web Developer", value: "backend_web_developer" },
      { label: "Frontend Web Developer", value: "frontend_web_developer" },
      { label: "Mobile Developer", value: "mobile_developer" },
      { label: "Native Developer", value: "native_developer" },
      { label: "Cloud Engineer", value: "cloud_engineer" },
      { label: "Data Scientist", value: "data_scientist" },
      { label: "DevSecOps", value: "devsecops" },
      { label: "Privacy Engineer", value: "privacy_engineer" },
      { label: "Tester", value: "tester" },
      { label: "Non-Developer", value: "business_learner" },
      { label: "Other", value: "other" },
    ],

    experienceLevels: [
      { label: "0-2 years of experience", value: "beginner" },
      { label: "3-5 years of experience", value: "intermediate" },
      { label: "5-10 years of experience", value: "advanced" },
      { label: "11+ years of experience", value: "experienced" },
    ],

    technicalExpertise: [
      { label: "I read or write code regularly", value: "reads_writes_code_regularly" },
      {
        label: "I understand code but do not write it",
        value: "understands_code_but_does_not_write_it",
      },
      { label: "I don't work directly with code", value: "does_not_work_directly_with_code" },
    ],

    programmingLanguages: [
      "Java",
      "Python",
      "JavaScript",
      "C#",
      "R",
      "Ruby",
      "Go",
      "Kotlin",
      "Swift",
      "C",
      "C++",
      "Apex",
      "Clojure",
      "Cobol",
      "Node.js",
      "Perl",
      "Rust",
      "Scala",
      "TypeScript",
      "PHP",
      "Other",
    ].map(language => ({ label: language, value: language.toLowerCase().replace(/\s/g, "_") })),

    architectureTools: [
      "Azure",
      "GCP",
      "AWS",
      "Docker",
      "Kubernetes",
      "Terraform",
      "Embedded",
      "Other",
    ].map(tool => ({ label: tool, value: tool.toLowerCase() })),
  },

  VALUES: {
    EXPERTISE_DOES_NOT_WORK_WITH_CODE: "does_not_work_directly_with_code",
    OTHER: "other",
  },

  TEXT: {
    HEADER: "Developer Profile",
    INTRO_MESSAGE: "Help us customize your experience by answering a few questions:",
    JOB_FUNCTION_LABEL:
      "What best describes your day-to-day job function within your organization?",
    EXPERIENCE_LABEL: "How many years of development experience do you have?",
    EXPERTISE_LABEL: "Which of the following best describes your technical expertise?",
    LANGUAGES_LABEL: "Which programming language or technology do you use most in your daily work?",
    TOPICS_LABEL: "Which best describes the architecture and tools/topics that you work on?",
    GITHUB_LABEL: "What is your GitHub username? (Optional)",
    JOB_FUNCTION_PLACEHOLDER: "Select Job Function",
    EXPERIENCE_PLACEHOLDER: "Select Experience Level",
    EXPERTISE_PLACEHOLDER: "Select Expertise",
    LANGUAGES_PLACEHOLDER: "Select Language",
    TOPICS_PLACEHOLDER: "Select Tool(s)",
    VALIDATION_MESSAGE: "Please make a selection to submit an answer.",
    OTHER_LABEL: "Please specify: ",
    OTHER_LANGUAGE_PLACEHOLDER: "Enter your language",
    OTHER_TOPIC_PLACEHOLDER: "Enter your topic",
  },
};
